module.exports = __webpack_public_path__ + "static/media/settings.a203ff1d.png";